var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5603 35.97C1.89062 35.97 1.24606 35.7105 0.752171 35.2166C0.065753 34.5302 -0.176997 33.5257 0.132729 32.5965L1.9827 27.0047C2.10827 26.628 2.3259 26.2764 2.60215 26.0002L27.8741 0.728273C28.8451 -0.242758 30.5277 -0.242758 31.4987 0.728273L35.2405 4.47009C36.2367 5.46624 36.2367 7.09857 35.2405 8.09471L9.9686 33.3666C9.68399 33.6512 9.34077 33.8605 8.96408 33.9861L3.37228 35.8361C3.10441 35.9281 2.82817 35.97 2.5603 35.97ZM29.6906 1.57374C29.4311 1.57374 29.1883 1.67419 29.0125 1.85835L3.74061 27.1303C3.63179 27.2391 3.55645 27.3647 3.50622 27.507L1.65625 33.0988C1.53906 33.4503 1.62276 33.8187 1.89063 34.0865C2.15013 34.346 2.51845 34.4381 2.8784 34.3209L8.47019 32.4709C8.6125 32.4207 8.74645 32.3454 8.8469 32.2365L34.1188 6.96464C34.4955 6.58794 34.4955 5.97686 34.1188 5.60017L30.377 1.85835C30.1928 1.67419 29.9501 1.57374 29.699 1.57374H29.6906Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40776 33.5926C9.20686 33.5926 8.99759 33.5173 8.83854 33.3583L2.60217 27.1219C2.29244 26.8122 2.29244 26.3015 2.60217 25.9918C2.91189 25.6821 3.42253 25.6821 3.73225 25.9918L9.96862 32.2282C10.2783 32.5379 10.2783 33.0485 9.96862 33.3583C9.80958 33.5173 9.60868 33.5926 9.39941 33.5926H9.40776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.cacea0f5166f901256a3571be5be0736.svg";
export { ForwardRef as ReactComponent };